angular.module('bmsApp.marketing').controller('CustomerGroupSaveCtrl',
	function (
		$scope,
		$rootScope,
		$log,
		CustomerGroupSvc,
		ngTableParams,
		$state,
		$q,
		$timeout,
		CustomerSvc,
		NoteSvc,
		notify) {

		$scope.existing = $state.is('main.marketing.customerGroupIndex.customerGroupEdit');
		$scope.loading = true;
		$scope.processing = false;
		$scope.updating = false;
		$scope.customerGroup = {};
		$scope.customers = {};
		$scope.checkboxes = {};

		$scope.loadCustomers = function () {
			$scope.tableParams = new ngTableParams(angular.extend({
				page: 1, // show first page
				count: $scope.config.table.params.count, // count per page
				sorting: {
					name: 'asc'     // initial sorting
				},
				filter: {
					search: ''
				},
				active: '',
			}), {
				total: 0, // length of data
				counts: $scope.config.table.settings.counts, // available page counts
				getData: function ($defer, params) {
					CustomerSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.customer_filtered_count);
							$scope.customers = response.data.customer_collection;
							$scope.loading = $scope.updating = false;
							$scope.checkboxes.checked = $scope.allChecked();
							$defer.resolve(response.data.customer_collection);
						});
				}
			});
		}

		var promises = [];
		if ($scope.existing) {
			groupPromise = CustomerGroupSvc.read($state.params.id);
			promises.push(groupPromise);

			$q.all(promises).then(function (responses) {
				$scope.customerGroup = responses[0].data.customer_group;
				$scope.customerGroup.customers = _.sortBy($scope.customerGroup.customers, function (customer) {
					return customer.name;
				});
				$scope.loadCustomers();
				$scope.note.api.showNotes();
			});

		}
		else {
			$scope.loadCustomers();
		}

		$scope.submit = function (customerGroup) {
			$scope.processing = true;
			var promise;
			promise = (customerGroup.id) ?
				CustomerGroupSvc.update(customerGroup.id, customerGroup) :
				CustomerGroupSvc.create(customerGroup);

			promise.then(function (response) {
				$scope.customerGroup.id = response.data.id;
				notify({
					message: $scope.existing ? 'Group updated successfully' : 'Group created successfully'
				});
				$state.go('main.marketing.customerGroupIndex');
			}, function (error) {
				$scope.errors = error;
			}).finally(function () {
				$scope.processing = false;
			});

		}

		$scope.filterChanged = function () {
			$scope.updating = true;
			$scope.tableParams.$params.filter.search = $scope.filterText;
		};


		$scope.removeCustomer = function (customer) {
			$scope.customerGroup.customers.splice($scope.customerGroup.customers.indexOf(customer), 1);
		}

		$scope.allChecked = function () {
			var allChecked = true;
			var customerIds = [];
			angular.forEach($scope.customerGroup.customers, function (value, key) {
				customerIds.push(value.id);
			});

			angular.forEach($scope.customers, function (v, k) {
				if (customerIds.indexOf(v.id) === -1) {
					allChecked = false;
				}
			});

			return allChecked;
		}

		$scope.customerGroupComparator = function (obj1, obj2) {
			return typeof obj1 !== 'undefined' && typeof obj2 !== 'undefined' && obj1.id === obj2.id;
		}

		$scope.checkboxClicked = function () {
			$timeout(function () {
				$scope.checkboxes.checked = $scope.allChecked();
			}, 0);
		}

		$scope.selectAllClicked = function (value) {
			$scope.customerGroup.customers = $scope.customerGroup.customers || [];

			if (value) {
				var customerGroupIds = [];
				angular.forEach($scope.customerGroup.customers, function (value, key) {
					customerGroupIds.push(value.id);
				});

				// if not in customer group, add to customer group
				angular.forEach($scope.customers, function (value, key) {
					if (customerGroupIds.indexOf(value.id) === -1) {
						$scope.customerGroup.customers.push(value);
					}
				});

				$scope.customerGroup.customers = _.sortBy($scope.customerGroup.customers, function (customer) {
					return customer.name;
				});
			}
			else {
				// uncheck
				angular.forEach($scope.customers, function (value, key) {
					angular.forEach($scope.customerGroup.customers, function (v, k) {
						if (v.id == value.id) {
							$scope.customerGroup.customers.splice(k, 1);
						}
					});
				});
			}

		}

		//$scope.tabNotes = function () {
		//	$scope.note.api.showNotes();
		//};

		$scope.note = {
			api: {}
		};

		$scope.addNote = function () {
			var note = {
				object_type: 'CustomerGroup',
				object_id: $scope.customerGroup.id
			};
			NoteSvc.showSaveModal(note);
		};

		$scope.$on('notesUpdated', function () {
			setActiveTab('notes');
		});
	});
